<template>
    <div id="leaseList">
        <table-title>筛选栏</table-title>
        <Form ref="formValidates" :model="queryParams" inline :label-width="100">
            <FormItem label="订单编号">
                <Input v-model="queryParams.orderNo" placeholder="订单编号" clearable style="width: 200px" />
            </FormItem>
            <FormItem label="交付计划编号">
                <Input v-model="queryParams.id" placeholder="交付计划编号" clearable style="width: 200px" />
            </FormItem>
            <!-- <FormItem label="仓库名称" v-if="leaseStorageSelectShow">
                    <dict-select namespace="bizObjects" id="warehouse" :exclusion="[]" v-model="queryParams.storageId" />
                </FormItem>
            <br />-->
            <FormItem label="交付方式" prop="deliveryMethod">
                <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="order.DeliveryMethod" :exclusion="[]" v-model="queryParams.deliveryMethod" />
            </FormItem>
            <br />
            <FormItem label="租借人">
                <leasee-select roleType="LEASEE" v-model="queryParams.leaseeId" />
            </FormItem>
            <FormItem label="标的物小类">
                <target-type-select @on-change="onTargetType" v-model="queryParams.targetType" />
            </FormItem>
            <FormItem label="标的物编码">
                <Select v-model="queryParams.targetCode" clearable style="width:200px">
                    <Option v-for="item in targetCodeList" :value="item.code" :key="item.code">{{ item.name }}</Option>
                </Select>
            </FormItem>
            <Button type="primary" @click="search">查询</Button>
        </Form>
        <!-- 交付计划列表 -->
        <table-title>交付计划列表</table-title>
        <data-grid ref="leaseClientPick" :columns="cols" :queryParams="queryParams" paramsName="param" :queryUrl="queryUrl" exportId="leaseClientPickMember" exportFileName="交付计划清单" :dataList="[]">
            <template #default="{columns, data}">
                <Table :columns="columns" :data="data" border stripe size="small">
                    <template #finishAmount="{row,index}">
                        <a href="javascript:;" v-if="row.finishAmount > 0 && row.deliveryMethod === 'SELF_PICK'" class="hoverCollection" style="color: #2d8cf0;padding:35px" @click="toRecord(row.id)">{{row.finishAmount}}</a>
                        <span v-else>{{row.finishAmount}}</span>
                    </template>
                    <template slot-scope="{row}" slot="status">
                        <Tag color="gold" v-if="row.status === 'NORMAL'">正常</Tag>
                        <Tag color="green" v-if="row.status === 'FINISH'">完成</Tag>
                        <Tag color="blue" v-if="row.status === 'TERMINATE'">中止</Tag>
                    </template>
                    <template slot-scope="{row}" slot="operation">
                        <!-- <Button type="primary" size="small" v-if="row.deliveryMethod === 'SELF_PICK' && row.status === 'NORMAL' && confirmButton" @click="stockRemoval(row.id)">自提确认</Button>
                        <Button type="warning" size="small" v-if="row.status === 'NORMAL' && confirmButton" style="margin-left:10px" @click="stop(row.id)">中止</Button> -->
                        <Button type="success" v-show="row.logisticTaskId" style="margin:3px 0 0 5px" size="small" @click="onQueryLogistics(row.logisticTaskId)">查看物流</Button>
                    </template>
                </Table>
            </template>
        </data-grid>
        <stock-removal :stockRemVal="stockRemVal" @search="search"></stock-removal>
        <to-record ref="toRecordRef" />
        <query-logistics ref='queryLogisticRef' />
    </div>
</template>
<script>
import tableTitle from 'components/tableTitle/tableTitle.vue'
import stockRemoval from '@/viewsComponent/lease/leaseClientPick/stockRemoval.vue'
import dictSelect from '@/components/select/dict-select'
import dataGrid from '@/components/datagrid.vue'
import targetTypeSelect from '@/components/select/targetTypeSelect'
import leaseeSelect from '@/components/select/payee-select'
import toRecord from '@/components/toRecord.vue'
import queryLogistics from '_c/queryLogistics'

export default {
    name: "leaseList",
    components: {
        tableTitle,
        stockRemoval,
        dictSelect,
        dataGrid,
        targetTypeSelect,
        leaseeSelect,//租借人
        toRecord,
        queryLogistics
    },
    data() {
        return {
            leaseStorageSelectShow: false,//查询条件仓库是否权限
            deliverStopComment: "",//交付中止备注
            confirmButton: false,//列表按钮权限
            queryUrl: "MID-OPERATE-LEASE/messageService/orderService/queryDeliveryPlans",
            queryParams: {
                id: "",
                storageId: "",
                targetType: "",
                orderNo: "",
                targetCode: "",
                leaseeId: "",
                deliveryMethod: "",
                pageNum: '',
                pageSize: ''
            },
            stockRemVal: {
                show: false,
                id: ""
            },
            targetCodeList: [],//标的物编码列表
            cols: [
                { title: '订单号', key: 'orderNo' },
                { title: '交付计划编号', key: 'id' },
                // { title: '仓库名称', key: 'storageId', dict: ['bizObjects', 'warehouse', true] },
                { title: '租借人', key: 'leaseeId', dict: ['bizObjects', 'member', true] },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true] },
                { title: '标的物编码', key: 'targetCode', dict: ['target', 'targetCodeLease', true] },
                { title: '交付计划总数量', key: 'totalAmount' },
                { title: '已交付数量', slot: 'finishAmount', width: 100 },
                { title: '状态', slot: 'status' },
                { title: '交付方式', key: 'deliveryMethod', dict: ['ENUM_MID-OPERATE-LEASE', 'order.DeliveryMethod'] },
                { title: '操作', slot: 'operation', align: 'center', width: 100 }
            ],
        }
    },
    created() {
        this.getButton()
    },
    methods: {
         // 查看物流
        onQueryLogistics(id){
            this.$refs['queryLogisticRef'].openModal(id);
        },
        // 查询
        search() {
            this.$refs['leaseClientPick'].loadFirstPage()
        },
        // 权限按钮
        getButton() {
            JSON.parse(sessionStorage.getItem('menuList')).map(item => {
                if (item == 'leaseDeliveryPlanButtons') {
                    this.confirmButton = true
                } else if (item == 'leaseDeliveryPlanStorageSelect') {
                    this.leaseStorageSelectShow = true
                }
            })
        },
        // 查看自提记录、查看附件
        toRecord(id) {
            let data = {
                url: "http://MID-OPERATE-LEASE/messageService/orderService/querySelfPickRecordsByDeliveryPlan",
                body: { deliveryPlanId: id }
            }
            this.$refs['toRecordRef'].openModal(data)

        },
        // 出库确认
        stockRemoval(id) {
            this.stockRemVal.show = true
            this.stockRemVal.id = id
        },
        onTargetType(params) {
            this.queryParams.targetType = params
            if (params) this.getTargetCode(params);
        },
        //中止
        stop(id) {
            let data = {
                url: 'MID-OPERATE-LEASE/messageService/orderService/terminateDeliveryPlan',
                body: { id, deliverStopComment: this.deliverStopComment }
            }
            this.$Modal.confirm({
                title: '确定要中止交付计划吗？',
                render: (h) => {
                    return h('Input', {
                        props: {
                            value: this.deliverStopComment,
                            autofocus: true,
                            type: 'textarea',
                            placeholder: '备注'
                        },
                        on: {
                            input: (val) => {
                                this.deliverStopComment = val;
                            }
                        },
                    })
                },
                onOk: () => {
                    data.body.deliverStopComment = this.deliverStopComment
                    this.invoke(data).then(res => {
                        if (!res) {
                            this.$Message.success('中止交付计划成功');
                            this.$refs['leaseClientPick'].loadFirstPage()
                            this.deliverStopComment = "";

                        }
                    })
                },
                onCancel: () => {
                    this.deliverStopComment = "";
                }
            });
        },
        async getTargetCode(targetType) {
            let data = {
                url: 'http://CORE-TARGET/messageService/leaseTargetService/queryLeaseTargetCodesByType',
                body: {targetType}
            }
            this.targetCodeList = await this.invoke(data)
        },
    }
};
</script>

<style lang="scss" scoped>
#leaseList {
    height: 100%;
    .hoverCollection:hover {
        text-decoration: underline;
    }
}
</style>